module.exports = __webpack_public_path__ + "static/images/duizhangdan.75bb2e87.jpg";